"use client";

import { useEffect } from "react";
import { localeDirection } from "@/lib/i18n/locales";
import { useLocale } from "@/lib/use-i18n";

export function LocaleDocumentSync() {
  const locale = useLocale();

  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dir = localeDirection(locale);
  }, [locale]);

  return null;
}
